import cx from 'classnames';
import React from 'react';

import colors from 'utils/colors';
import * as Styling from 'utils/styled';

import * as Elements from './Elements';
import { IconProps } from './interfaces';

const CircleArrowRight: React.FC<IconProps> = ({
  className = '',
  fill = colors.white,
  viewBox = '0 0 30 30',
  cssHelper = Styling.fullWidthStyle,
  focusable
}) => {
  return (
    <Elements.Svg
      className={cx({ [className]: !!className })}
      viewBox={viewBox}
      cssHelper={cssHelper}
      role='img'
      focusable={!!focusable}
      aria-hidden={!focusable}>
      <Elements.Path
        color={fill}
        fill={fill}
        d='M15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0zm2.713 11l-1.374 1.282 1.942 1.812H8v1.812h10.28l-1.94 1.812L17.712 19 22 15l-4.287-4z'
        transition='fill 0.1s ease-in-out'
      />
    </Elements.Svg>
  );
};

export default CircleArrowRight;
